import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { toast } from "../../../../../core/helpers/message-helper";
import {
    asignarActividadCuadroTurno,
    selectActividad,
} from "../../../../Actividades/services/actividades-service";
import ContainerOpciones from "../ContainerOpciones/container-opciones";
import useTurno from "../../../../../core/hooks/use-turno";

const ESTILO_ELIMINAR_ACTIVIDAD = {
    borderRadius: "50%",
    border: "none",
    backgroundColor: "red",
    color: "white",
    fontWeight: "bold",
    display: "none",
};

const OpcionesActividades = ({ sedeAreaLider }) => {
    const [selectActividades, setSelectActividades] = useState([]);
    const { obtenerTurnosSeleccionados } = useTurno();

    useEffect(() => buscarActividades(), [sedeAreaLider]);

    const buscarActividades = async () => {
        const resp = await selectActividad(sedeAreaLider);
        if (!resp.status) return toast.error(resp.message);
        setSelectActividades(resp.data);
    };

    const onBuscar = (evento) => {
        const busqueda = evento.target.value ?? "";
        const opciones =
            document.querySelectorAll(
                ".opciones .lista-opciones-actividades .opcion"
            ) ?? [];

        opciones.forEach((opcion) => {
            let { nombre } = opcion.dataset;
            nombre = nombre.toUpperCase();

            if (nombre.includes(busqueda.toUpperCase())) {
                opcion.style.display = "flex";
            } else {
                opcion.style.display = "none";
            }
        });
    };

    const onClickOpcion = async (actividad) => {
        const turnosSeleccionados = obtenerTurnosSeleccionados();

        turnosSeleccionados.forEach(async (turno) => {
            const { idceldaturno, idcuadroturno } = turno;

            const iconos =
                document.querySelectorAll(
                    `#${idceldaturno} .iconos-actividades .actividad`
                ) ?? [];

            const idsActividadesSeleccionadas = [];

            for (const icono of iconos) {
                if (icono.classList.contains(`actividad-${actividad.id}`))
                    return;
                idsActividadesSeleccionadas.push(icono.dataset.id);
            }

            const actividadSpanId = `#${idceldaturno} .iconos-actividades`;

            const icono = document.createElement("i");
            icono.dataset.id = actividad.id;
            icono.className = `${actividad.icono} actividad-${actividad.id} actividad`;
            icono.style.color = actividad.color;

            let span = document.querySelector(actividadSpanId);

            if (!span) {
                span = document.createElement("span");
                span.className = "iconos-actividades";
                span.appendChild(icono);
                const celda = document.getElementById(idceldaturno);
                celda.appendChild(span);
            } else {
                span.appendChild(icono);
            }

            const botonActividad = document.getElementById(
                `boton-opcion-actividad-${actividad.id}`
            );

            botonActividad.style.display = "";

            const resp = await asignarActividadCuadroTurno(idcuadroturno, [
                ...idsActividadesSeleccionadas,
                actividad.id,
            ]);

            if (!resp.status) {
                botonActividad.style.display = "none";
                toast.error(resp.message);
            }
        });
    };

    const eliminarActividad = async (actividad) => {
        const turnosSeleccionados = obtenerTurnosSeleccionados();
        turnosSeleccionados.forEach(async (turno) => {
            const { idceldaturno, idcuadroturno } = turno;

            const iconos =
                document.querySelectorAll(
                    `#${idceldaturno} .iconos-actividades .actividad`
                ) ?? [];

            const idsActividadesSeleccionadas = [];

            for (const icon of iconos) {
                if (icon.dataset.id != actividad.id) {
                    idsActividadesSeleccionadas.push(icon.dataset.id);
                }
            }

            const botonActividad = document.getElementById(
                `boton-opcion-actividad-${actividad.id}`
            );

            botonActividad.style.display = "none";

            const iconoAEliminar = document.querySelector(
                `#${idceldaturno} .iconos-actividades .actividad-${actividad.id}`
            );
            iconoAEliminar && (iconoAEliminar.style.display = "none");

            const resp = await asignarActividadCuadroTurno(
                idcuadroturno,
                idsActividadesSeleccionadas
            );

            if (!resp.status) {
                iconoAEliminar && (iconoAEliminar.style.display = "");
                return toast.error(resp.message);
            }

            iconoAEliminar && iconoAEliminar.remove();
        });
    };

    return (
        <ContainerOpciones
            tipo="actividades"
            onBuscar={onBuscar}
            opciones={selectActividades.map((actividad) => {
                return (
                    <li
                        id={`opcion-actividad-${actividad.id}`}
                        onClick={() => onClickOpcion(actividad)}
                        key={actividad.id}
                        className="opcion"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                        data-nombre={actividad.nombre}
                    >
                        <span>
                            {actividad.nombre}
                            <i className={`${actividad.icono} ml-1`} style={{color: actividad.color}}></i>
                        </span>
                        <button
                            id={`boton-opcion-actividad-${actividad.id}`}
                            data-actividad={actividad.id}
                            style={ESTILO_ELIMINAR_ACTIVIDAD}
                            onClick={(e) => {
                                e.stopPropagation();
                                eliminarActividad(actividad);
                            }}
                        >
                            X
                        </button>
                    </li>
                );
            })}
        />
    );
};

OpcionesActividades.propTypes = {
    sedeAreaLider: PropTypes.number,
};

export default OpcionesActividades;
